"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWrapperStyled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SubscriptionManagementStyled = require("../SubscriptionManagement/SubscriptionManagementStyled");
var _templateObject;
/* eslint-disable import/prefer-default-export */
var ButtonWrapperStyled = (0, _styledComponents.default)(_SubscriptionManagementStyled.WrapperStyled)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  justify-content: flex-end;\n"])));
exports.ButtonWrapperStyled = ButtonWrapperStyled;